import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

jQuery(document).ready(function ($) {
  gsap.registerPlugin(ScrollTrigger);

  let ctx;
  let resizeTimeout;

  const initServicesAnimation = () => {
    if (ctx) ctx.revert();

    const container = document.querySelector('.our-services');
    if (!container) return;

    ctx = gsap.context(() => {
      const $items = $('.our-services__item');
      const $images = $('.our-services__image-wrapper');

      if (!$items.length || !$images.length) return;

      gsap.set($images, { yPercent: 100, zIndex: 0 });
      gsap.set($images.eq(0), { yPercent: 0, zIndex: 1 });

      $items.each(function (i, item) {
        ScrollTrigger.create({
          trigger: item,
          start: 'top 50%',
          end: 'bottom center',
          onEnter: () => swipeImage(i),
          onEnterBack: () => swipeImage(i),
        });
      });

      function swipeImage(index) {
        $images.each(function (i, img) {
          gsap.to(img, {
            yPercent: i < index ? -100 : i > index ? 100 : 0,
            zIndex: i === index ? 1 : 0,
            duration: 0.8,
            ease: 'power2.out',
            overwrite: true,
          });
        });
      }

      ScrollTrigger.refresh();
    }, container);
  };

  initServicesAnimation();

  $(window).on('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initServicesAnimation();
    }, 300);
  });
});
